// extracted by mini-css-extract-plugin
module.exports = {"clickable":"CollapsibleCard_clickable__3fLzD","smoothIcon":"CollapsibleCard_smoothIcon__T9uDG","card":"CollapsibleCard_card__C3E49"};